/* eslint-disable indent */
import React, { useState } from "react";
import sanitizeHtml from 'sanitize-html';
import { dummyAuctoinDescription } from "../../config/constant";

const Description = ({
    style = {},
    description = '',
    isSingleLotView = false,
    emptyDescriptionPlaceholder = dummyAuctoinDescription,
    className
}) => {
    const [isFullTextShown, setIsFullTextShown] = useState(false);
    const fullDescription = (description.trim() && description!=='<p><br/></p>') ? description : emptyDescriptionPlaceholder

    const extractImages = (html) => {
        const srcs = [];
        const htmlWithoutSrc = html.replace(/<img[^>]*src=["']([^"']+)["'][^>]*>/gi, (match, src) => {
        srcs.push(src);
        return match.replace(src, "");
        });
        return { htmlWithoutSrc, srcs };
    };

    // Restore the srcs back into img tags
    const restoreImages = (html, srcs) => {
        let i = 0;
        return html.replace(/<img\b[^>]*?>/gi, (match) => {
            if (/src=["'][^"']*["']/.test(match)) {
            return match.replace(/src=["'][^"']*["']/, `src="${srcs[i++]}"`);
            }
            else if (/src=["']["']/.test(match)) {
            return match.replace(/src=["']["']/, `src="${srcs[i++]}"`);
            } else {
            return match.replace(/<img/, `<img src="${srcs[i++]}"`);
            }
        });
    };

    const { htmlWithoutSrc, srcs } = extractImages(fullDescription);

    const LENGTH = 1000;
    const shouldDisplayButton = htmlWithoutSrc?.length > LENGTH;

    const content = isFullTextShown ? fullDescription : htmlWithoutSrc.slice(0, LENGTH);
    const descriptionContent = restoreImages(content, srcs);
    const buttonText = isFullTextShown ? 'Read less' : 'Read more';
    /**
     * The function "renderHTML" takes an HTML string, sanitizes it, and returns an object with a
     * property "__html" containing the sanitized HTML.
     * @param htmlString - The `htmlString` parameter is a string that represents an HTML code or
     * markup. It can contain tags, attributes, and content that make up an HTML document or a portion
     * of it.
     * @returns An object with a property named "__html" that contains the sanitized HTML string.
     */
    function renderHTML(htmlString) {

        const fixedString = htmlString.replace(/&nbsp;/g, ' ');

        const sanitizedHTML = sanitizeHtml(fixedString, {
            allowedTags: sanitizeHtml.defaults.allowedTags.concat(['iframe', 'img']),
            allowedAttributes: {
                iframe: ['*'], 
                img: ['*'],
                span: ['*'],
                a: ['href', 'target', 'rel'], 
                '*': ['style', 'class']
            },
            allowedSchemesByTag: {
                img: ['http', 'https', 'data'],
                a: ['http', 'https'] 
            },
            allowedStyles: {
                '*': {
                    '*': true
                }
            }
        });
        return { __html: sanitizedHTML };
    }

    return (
        <div className="ql-editor">
            <div
                data-testid='auction-description'
                id='updated_auction-description'
                className={`text-[16px] leading-normal break-normal
                    ${(!isFullTextShown && shouldDisplayButton)
                        ? 'bg-clip-text bg-gradient-to-b from-black to-transparent'
                        : 'text-[#343434]'}
                    ${(!isSingleLotView && shouldDisplayButton)
                        ? 'h-auto overflow-hidden transition-max-height duration-1000 ease-in-out'
                        : ''}
                    ${isSingleLotView
                        ? 'text-[16px] pt-2.5  leading-normal text-[#343434] break-normal'
                        : ''}
                `} 
                /* 
                * Used webkitmask image instead of text-transparent because 
                * transparent text makes line-through effect non-visible
                */
                style={{
                    ...style,
                    WebkitMaskImage: !isFullTextShown && shouldDisplayButton
                    ? 'linear-gradient(to bottom, black 50%, transparent 100%)'
                    : 'none',
                    maskImage: !isFullTextShown && shouldDisplayButton
                        ? 'linear-gradient(to bottom, black 50%, transparent 100%)'
                        : 'none',
                }}
                dangerouslySetInnerHTML={renderHTML(descriptionContent)}/>
            {shouldDisplayButton && (
                <div className={`${!isSingleLotView && 'flex justify-center' } `}>
                    <button onClick={() => setIsFullTextShown(!isFullTextShown)} className=' underline' >
                        {buttonText}
                    </button>
                </div>
            )}
        </div>
    )
}

export const AuctionDescription = React.memo(Description, (prevProp, nextProp) => {
    return (
        prevProp.description === nextProp.description &&
        JSON.stringify(prevProp.style) === JSON.stringify(nextProp.style)
    );
});